import { tabletMatchMedia } from './utility';

const FOCUSABLE =
  'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

export default function toggleMenu(selector = '.js-button') {
  const button = document.querySelector(selector);
  const menu = document.querySelector('.js-menu');
  if (!button || !menu) return;

  let open = false;

  const setOpen = (isOpen) => {
    open = isOpen;
    button.classList.toggle('is-active', isOpen);
    document.body.classList.toggle('is-open', isOpen);
    button.setAttribute('aria-expanded', isOpen);
    button.setAttribute('aria-label', isOpen ? 'メニューを閉じる' : 'メニューを開く');
    document.body.style.overflow = isOpen ? 'hidden' : '';
  };

  const onKeydown = (e) => {
    if (e.key === 'Escape' && open) {
      setOpen(false);
      button.focus();
      return;
    }
    if (e.key !== 'Tab' || !open) return;
    const focusable = [...menu.querySelectorAll(FOCUSABLE)].filter((el) => !el.closest('[inert]'));
    if (focusable.length < 2) return;
    const el = document.activeElement;
    const first = focusable[0];
    const last = focusable.at(-1);
    if (e.shiftKey && el === first) {
      last.focus();
      e.preventDefault();
    } else if (!e.shiftKey && el === last) {
      first.focus();
      e.preventDefault();
    }
  };

  button.addEventListener('click', () => setOpen(!open));
  document.addEventListener('keydown', onKeydown);
  window.addEventListener('resize', () => {
    if (!tabletMatchMedia.matches && open) setOpen(false);
  });
  document.addEventListener('closeNavigationMenu', () => setOpen(false));
}
